<template id="dialog">
  <div @click="openChat()" class="dialog" :class="{dialog_new: getUnviewed() && getUnviewed().length > 0, active: isActive}">
      <div class="dialog-avatar" :style="{ backgroundImage: 'url(' + getCover + ')' }">
          <p>{{ }}</p>
          <div class="dialog-online" v-if="isDialog ? isOnline : false"></div>
          <div class="dialog-collage" v-if="!dialog.cover && !isDialog" :class="getClassCount">
            <div class="dialog-collage__item" v-for="user in dialog.users" :key="user.id" :style="{ backgroundImage: 'url(' + getAvatar(user) + ')' }"></div>
          </div>
          <div v-if="getUnviewed() && getUnviewed().length > 0" class="dialog-notifications">{{ getUnviewed().length }}</div>
      </div>
      <div class="dialog-content">
          <p class="dialog__title">{{ isDialog ? getNameOponent : cutString(dialog.caption, '20') }}</p>
          <p class="dialog__text">{{ getLastMessage() }}</p>
          <div class="dialog-mute" v-if="isMuted">
            <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="volume-slash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="svg-inline--fa fa-volume-slash fa-w-20" style="--fa-secondary-opacity:1; --fa-primary-opacity:0.1;"><g class="fa-group"><path d="M393.11 107.22a23.9 23.9 0 0 1 33.12-7.46A185.33 185.33 0 0 1 488.74 346l-38.65-29.9a136.7 136.7 0 0 0-49.57-175.52 24.29 24.29 0 0 1-7.41-33.36zm60.68-46.79a233.7 233.7 0 0 1 73 315l38.52 29.78A282.1 282.1 0 0 0 480.35 20a24.2 24.2 0 1 0-26.56 40.46zM347.07 221.19a40 40 0 0 1 20.75 31.32l42.92 33.18A86.79 86.79 0 0 0 416 256a87.89 87.89 0 0 0-45.78-76.86 24 24 0 1 0-23.16 42.06zM288 190.82V88c0-21.46-26-32-41-17l-49.7 49.69zM32 184v144a24 24 0 0 0 24 24h102.06L247 441c15 15 41 4.47 41-17v-71.4L43.76 163.84C36.86 168.05 32 175.32 32 184z" class="fa-secondary"></path><path d="M594.54 508.63L6.18 53.9a16 16 0 0 1-2.81-22.45L23 6.18a16 16 0 0 1 22.47-2.81L633.82 458.1a16 16 0 0 1 2.82 22.45L617 505.82a16 16 0 0 1-22.46 2.81z" class="fa-primary"></path></g></svg>
          </div>
      </div>
  </div>
</template>

<script>

  export default {
    name: 'Dialog',
    props: {
      dialog: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      active: false,
      new_messages: 0
    }),
    sockets: {
      new_message(message) {
        if (this.dialog.id == message.chat) {
          this.dialog.last_message =  {author: message.user ? message.user : '', message: message.message}
        }
      }
    },
    computed: {
      isOnline() {
        let five_mins_ago = Date.now() - 5 * 60 * 1000;
        let last_ac = new Date(this.getOponent.last_activity);
        return this.getOponent ? last_ac > five_mins_ago : null
      },
      getNotifications() {
        return this.$store.getters.getUserNotifications
      },
      isActive() {
        let hash = this.$route.params.hash;
        let h_array = hash ? hash.split('&') : hash;
        let id = h_array ? h_array[0] : hash;
        return this.dialog && id ? this.dialog.id == id : false
      },
      getClassCount() {
        let result = 'one';
        if (this.dialog.users.length > 3) {
          result = 'four'
        } else if (this.dialog.users.length == 2) {
          result = 'two'
        } else if (this.dialog.users.length == 3) { 
          result = 'tree'
        }
        return result
      },
      getUser () {
        return this.$store.getters.getAuthUser
      },
      isMuted() {
        return this.getUser && this.getUser.muted_chats 
          ? this.getUser.muted_chats.find(chat => chat == this.dialog.id) 
          : false
      },
      getOponent() {
        return this.getUser 
          ? this.dialog.users.find(user => user.id !== this.getUser.id)
          : null;
      },
      getNameOponent() {
        return this.getOponent 
          ? this.getOponent.firstname + ' ' + this.getOponent.lastname
          : null;
      },
      isDialog() {
        return this.dialog.type === 'dialog'
      },
      getCover () {
        return this.isDialog && this.getOponent 
          ? this.getAvatar(this.getOponent) 
          : this.dialog.cover
      }
    },
    methods: {
      getAvatar(user) {
        return user.deleted ? require('@/assets/images/defaults/dead.svg') : user.avatar
      },
      openChat() {
        let long_hash = this.dialog.id + '&' + this.dialog.hash;
        if (this.$route.params.hash === long_hash) {
          this.$store.dispatch('changeState', {element: 'chat_list', val: false})
        } else {
          this.$router.push({name: 'chat', params: {hash: long_hash}})
        }
      },
      getLastMessage() {
        let author = this.dialog.last_message && this.dialog.last_message.author
          ? typeof this.dialog.last_message.author == 'string'
            ? JSON.parse(this.dialog.last_message.author).firstname + ': ' + this.dialog.last_message.message
            : this.dialog.last_message.author.firstname + ': ' + this.dialog.last_message.message
          : 'Без сообщений';
        return this.cutString(author, 30) 
      },
      getUnviewed() {
        let result = null;
        if (this.getNotifications && this.getNotifications.messages && this.getNotifications.messages.all && this.getNotifications.messages.all.rows) {
          result = this.getNotifications.messages.all.rows.filter(message => message.chat === this.dialog.id)
        }
        return result
      },
      cutString (val, length) {
        if (val) {
            val = val.length > length ? val.slice(0, length).concat('...') : val;
        }
        return val
      }
    },
    mounted(){
      this.active = this.getActive === this.article ? true : false;
    }
  }
</script>
<style lang="stylus">
.dialog
    width 100%
    border-radius 20px
    padding 12px
    display flex
    align-items center
    cursor pointer
    transition 0.3s all
    margin 5px 0
    position relative
    +to-width(540px)
      padding 10px
      margin 0

    &_new
        background #F3F6FB

    &-online
      position absolute
      right 0
      top 0
      width 15px
      height 15px
      border 2px solid white
      border-radius 50%
      background-color #51ea08

    &-mute
      position absolute
      right 15px
      top 15px
      width 16px
      height 16px

    &-collage
      position absolute
      left 0
      top 0
      right 0
      bottom 0
      display flex
      flex-wrap wrap
      overflow hidden
      border-radius 50%
      &__item
        background-size cover
        width 100%
      &.two
        .dialog-collage__item
          width 50%
      &.tree
        .dialog-collage__item
          &:first-child
            width 50%
          &:nth-child(2)
            width 50%
          &:nth-child(3)
            width 100%
      &.four
        .dialog-collage__item
          width 50%


    &-avatar
        min-width 55px
        width 55px
        height 55px
        border-radius 50%
        border 2px solid white
        background white
        margin-right 20px
        position relative
        background-size cover
    
    &-notifications
        min-width 21px
        height 21px
        border-radius 10px
        padding 0 4px
        border 2px solid white
        background #5fd58e
        position absolute
        left 30px
        top -4px
        display flex
        align-items center
        justify-content center
        color white
        font-weight 600
    
    &__title
        font-size 15px
        font-weight 500
        font-weight 600
        color #44434e
        color var(--text-main)
        padding-bottom 10px
        +to-width(480px)
          font-size 15px
          padding-bottom 12px
    
    &__text
        font-size 13px
        color #89b3d2
        color #6badbb
        +to-width(480px)
          font-size 11px
    
    &:hover
        background-color var(--main)
        .dialog__title
            color white
        .dialog-mute
          .fa-secondary
            fill white
    &.active
        background-color var(--main)
        .dialog-mute
          .fa-secondary
            fill white
        .dialog__title
            color white
</style>